import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { routePaths } from '@constants/index';
import { AuthGuardService, AdminAuthGuardService } from '@core/services';

const routes: Routes = [
  {
    path: routePaths.root,
    loadChildren: () =>
      import('./modules/onboarding/onboarding.module').then(
        (m) => m.OnboardingModule
      ),
    // canActivate: [AuthGuardService],
  },
  {
    path: routePaths.dashboard,
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    // canActivate: [AuthGuardService],
  },
  {
    path: routePaths.itrProfile,
    loadChildren: () =>
      import('./modules/itr-profile/itr-profile.module').then(
        (m) => m.ItrProfileModule
      ),
    // canActivate: [AuthGuardService],
  },
  {
    path: `${routePaths.itrSlips}`,
    loadChildren: () =>
      import('./modules/itr-slips/itr-slips.module').then(
        (m) => m.ItrSlipsModule
      ),
    // canActivate: [AuthGuardService],
  },
  {
    path: `${routePaths.myProfile}`,
    loadChildren: () =>
      import('./modules/user-profile/user-profile.module').then(
        (m) => m.UserProfileModule
      ),
    // canActivate: [AuthGuardService]
  },
  {
    path: `${routePaths.itrProvincial}`,
    loadChildren: () =>
      import('./modules/itr-provincial/itr-provincial.module').then(
        (m) => m.ItrProvincialModule
      ),
    // canActivate: [AuthGuardService]
  },
  {
    path: `${routePaths.admin}`,
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    // canActivate: [AuthGuardService, AdminAuthGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
